/**
 * https://developer.openstack.org/api-ref/image/v2/index.html
 */

import {
    CreateImageResponce,
    LoadImagesResponce,
} from 'images/modules/ImagesModule/ImagesModule.types';
import R from 'ramda';
import {
    ExtendedXhrOptions,
    OpenStackApiHelper,
} from 'utils/OpenStackApiHelper/OpenStackApiHelper';

const IMAGE_URL = '/infra/image/v2.1/images';

export const ImageApi = {
    async loadList({ marker, limit }: { marker?: string; limit: number }) {
        const { images } = await OpenStackApiHelper.openstackRpcCall<
            LoadImagesResponce
        >({
            url: IMAGE_URL,
            data: {
                marker,
                limit,
                member_status: 'all',
            },
        });

        return images;
    },

    removeImage(id: string) {
        return OpenStackApiHelper.openstackRpcCall({
            url: `${IMAGE_URL}/${id}`,
            method: 'DELETE',
        });
    },

    createImage(
        name: string,
        { onprogress, saveAbortFunction }: ExtendedXhrOptions = {},
    ) {
        return OpenStackApiHelper.openstackRpcCall<CreateImageResponce>({
            url: IMAGE_URL,
            method: 'POST',
            data: {
                name,
                store: 's3',
            },
            options: {
                onprogress,
                saveAbortFunction,
            },
        });
    },

    shareWithProjects(imageId: string, projectIds: string[]) {
        return Promise.all(
            R.map(R.partial(ImageApi.shareWithProject, [imageId]), projectIds),
        );
    },

    shareWithProject(id: string, projectId: string) {
        return OpenStackApiHelper.openstackRpcCall({
            url: `${IMAGE_URL}/${id}/members`,
            method: 'POST',
            data: {
                member: projectId,
            },
        });
    },

    uploadImageData(
        id: string,
        file: File,
        { onprogress, saveAbortFunction }: ExtendedXhrOptions = {},
    ) {
        return OpenStackApiHelper.openstackRpcCall<CreateImageResponce>({
            url: `${IMAGE_URL}/${id}/stage`,
            method: 'PUT',
            data: file,
            options: {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                contentType: 'application/octet-stream',
                processData: false,
                timeout: 0,
                onprogress,
                saveAbortFunction,
            },
        });
    },

    importImage(
        id,
        { onprogress, saveAbortFunction }: ExtendedXhrOptions = {},
    ) {
        return OpenStackApiHelper.openstackRpcCall<CreateImageResponce>({
            url: `${IMAGE_URL}/${id}/import`,
            method: 'POST',
            data: {
                method: {
                    name: 'glance-direct',
                },
            },
            options: {
                onprogress,
                saveAbortFunction,
            },
        });
    },
};
